import {API_URL} from "../../dev";

import "isomorphic-fetch";

class FileApi {
	async getMetaData(id) {
		try {
			const metaDataResponse = await fetch(`${API_URL}/v1/files/metaData/${id}`);
			const metaDataObj = await metaDataResponse.json();
			if (metaDataResponse.ok) {
				return metaDataObj;
			}
			throw metaDataObj;
		} catch (e) {
			console.error(`Error occurred in getMetaData ${id}: ${JSON.stringify(e)}`);
			throw e;
		}
	}
}
const fileApi = new FileApi();
export default fileApi;
